"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeCurrentMarkers = exports.addMarkerAtPointer = exports.addExclusiveMarkerOnTap = void 0;
var MapConstants = _interopRequireWildcard(require("./constants"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// Map pointer event handler for adding a marker at the location of click event
var addMarkerAtPointer = function addMarkerAtPointer(map, evt, config) {
  var _config$options;
  // require map and ensure that map pointer exists on event
  if (!map || !evt.currentPointer) return;

  // determine the -geographic- coords of the pointer event
  var mapPointer = evt.currentPointer;
  var mapX = mapPointer.viewportX;
  var mapY = mapPointer.viewportY;
  var coords = map.screenToGeo(mapX, mapY);
  var icon;
  if (config && (_config$options = config.options) !== null && _config$options !== void 0 && _config$options.icon) {
    var iconSize = config.options.icon.size ? config.options.icon.size : MapConstants.smallIconSize;
    var iconElement = document.createElement('img');
    iconElement.src = config.options.icon.iconSrc || "";
    icon = new H.map.Icon(iconElement, {
      crossOrigin: false,
      size: iconSize
    });
  } else icon = undefined;

  //let type: MapInterfaces.EHereMapMarkerType = markerConfig.type;
  //let position: H.geo.IPoint = markerConfig.position;
  var options = _objectSpread(_objectSpread({}, config === null || config === void 0 ? void 0 : config.options), {}, {
    icon: icon
  });
  //let data: any = markerConfig.data;

  // create a new marker at the given coords and add to map
  var markerToAdd = new H.map.Marker(coords, options);
  map.addObject(markerToAdd);
};

// Creates a tap listener that adds a Marker at the event coords
exports.addMarkerAtPointer = addMarkerAtPointer;
var addExclusiveMarkerOnTap = {
  type: "tap",
  action: function action(evt, map) {
    removeCurrentMarkers(map);
    addMarkerAtPointer(map, evt);
  }
};

// Removes all of the Marker Objects from the map ( ignores other Map Objects)
exports.addExclusiveMarkerOnTap = addExclusiveMarkerOnTap;
var removeCurrentMarkers = function removeCurrentMarkers(map) {
  var currentMarkers = map.getObjects().filter(function (object) {
    return object instanceof H.map.Marker;
  });
  map.removeObjects(currentMarkers);
};
exports.removeCurrentMarkers = removeCurrentMarkers;